<ui-grid
  [rowData]="missions"
  [columnDefs]="colDefs"
  [defaultColDef]="sampleDefaultColDef"
  [showPanelHeader]="true"
  [panelHeaderConfig]="panelHeaderConfig"
  [agGridOptions]="agGridOptions"
></ui-grid>
